module.exports = __webpack_public_path__ + "static/media/015ty@2x.edc41885.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/015ty@2x.png
// module id = 1663
// module chunks = 0 1